import { render, staticRenderFns } from "./DashboardItem.vue?vue&type=template&id=7cb89896&"
import script from "./DashboardItem.vue?vue&type=script&lang=ts&"
export * from "./DashboardItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports